/* global angular */

angular.module('AemEcbBranchesSnippet')
  .controller('aemEcbBranchesSnippetCtrl', ctrl)

ctrl.$inject = ['appLoader', 'wgService', 'i18n', '$filter', 'googleMapsService', '$q', 'widgetParamsService']

function ctrl (appLoader, wgService, i18n, $filter, googleMapsService, $q, widgetParamsService) {
  var vm = this

  vm.$onInit = function () {
    appLoader.hide()
    vm.search = search
    vm.showSearch = false
    vm.showDetail = false
    vm.isErrorBackend = false
    vm.widgetParams = null

    $q.all([
      googleMapsService.initPromise(),
      widgetParamsService.get(wgService.getAppName())
    ]).then(function (res) {
      vm.widgetParams = res[1].data
      vm.showSearch = true
    })
  }

  function search () {
    var targetUrl = ''
    var targetUrlparam = wgService.getParams().widgetUrl
    if (targetUrlparam && angular.isString(targetUrlparam)) {
      targetUrl = targetUrlparam
    } else if (angular.isObject(targetUrlparam) && targetUrlparam[i18n.langCode]) {
      targetUrl = targetUrlparam[i18n.langCode]
    } else if (angular.isObject(targetUrlparam) && targetUrlparam['cs']) {
      targetUrl = targetUrlparam['cs']
    }
    targetUrl = targetUrl.split('#')[0]
    window.location.href = targetUrl + '#/' + $filter('translate')('PLACES.URL.SEARCH')
  }
}
